import { Routes } from '@angular/router';

import { BlankLayoutComponent } from './common/layouts/blankLayout.component';
import { BasicLayoutComponent } from './common/layouts/basicLayout.component';
import { PrepareGuard } from 'app/core/prepare.guard';
import { HomeComponent } from 'app/common/layouts/home/home.component';
import { LoginComponent } from 'app/common/layouts/login/login.component';
import { AuthGuard } from './core/auth.guard';

export const ROUTES: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '',
        component: BasicLayoutComponent,
        children: [{ path: 'home', component: HomeComponent, data: { title: 'Home' }, canActivate: [AuthGuard, PrepareGuard] }],
    },
    {
        path: '',
        component: BlankLayoutComponent,
        children: [{ path: 'login', component: LoginComponent, data: { title: 'Login' } }],
    },
    {
        path: 'mobile',
        loadChildren: () => import('./mobile/tabs/tabs.module').then(m => m.TabsPageModule)

        // canActivate: [AuthGuard, PrepareGuard]
        // children: [{ path: 'time-entry', component: SchedulePage, data: { title: 'Home' }, canActivate: [AuthGuard, PrepareGuard] }],
        // children: [
        //     { path: 'time-entry',
        //     loadChildren: () => import('./mobile/tabs/tabs.module').then(m => m.TabsPageModule)
        // }]
            
            // component: SchedulePage, data: { title: 'Home' }, canActivate: [AuthGuard, PrepareGuard] }],
    },

    // Handle all other routes
    {
        path: 'mobile/drivers/trip-record',
        loadComponent: () => import('./mobile/drivers/trip-record/trip-record.page').then(m => m.TripRecordPage)
    },
    { path: '**', redirectTo: 'home' },
];
